import { render, staticRenderFns } from "./contest.vue?vue&type=template&id=c229d324"
import script from "./contest.vue?vue&type=script&lang=js"
export * from "./contest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports